<template>
  <template v-if="isRange">
    <div :class="[$style.field, $style.hasClearButton]">
      <DatePicker
        v-model="modelStartProxy"
        :popover="popoverOptions"
      >
        <template #default="{ inputValue, inputEvents }">
          <span
            :class="[
              $style.value,
              {
                [$style.placeholder]: !inputValue,
              },
            ]"
            v-on="inputEvents"
          >
            {{ inputValue || 'Start date' }}
          </span>
        </template>
      </DatePicker>
      <span :class="$style.divider">–</span>
      <DatePicker
        v-model="modelEndProxy"
        :popover="popoverOptions"
      >
        <template #default="{ inputValue, inputEvents }">
          <span
            :class="[
              $style.value,
              {
                [$style.placeholder]: !inputValue,
              },
            ]"
            v-on="inputEvents"
          >
            {{ inputValue || 'End date' }}
          </span>
        </template>
      </DatePicker>
      <button
        :class="[
          $style.clear,
          {
            [$style.isHidden]: modelStartProxy == null && modelEndProxy == null,
          }
        ]"
        type="button"
        @click="clear"
      >
        <CrossSvg />
      </button>
    </div>
  </template>
  <template v-else>
    <div :class="$style.field">
      <DatePicker
        v-model="modelProxy"
        :class="$style.picker"
        :popover="popoverOptions"
        :model-config="modelConfig"
      >
        <template #default="{ inputValue, inputEvents }">
          <span
            :class="[
              $style.value,
              $style.pickerValue,
              {
                [$style.placeholder]: !inputValue,
              },
            ]"
            v-on="inputEvents"
          >
            {{ inputValue || 'Select date' }}
          </span>
        </template>
      </DatePicker>
    </div>
  </template>
</template>

<script>
import { DatePicker } from 'v-calendar';
import CrossSvg from '@/assets/images/icons/cross.svg?inline';

export default {
  components: {
    DatePicker,
    CrossSvg,
  },
  props: {
    modelValue: {
      type: [Object, String],
      default: null,
    },
    modelConfig: {
      type: Object,
      default: null,
    },
    isRange: {
      type: Boolean,
      default: false,
    },
  },
  emits: {
    'update:modelValue': null,
  },
  data() {
    return {
      popoverOptions: {
        positionFixed: true,
      },
    };
  },
  computed: {
    modelProxy: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },
    modelStartProxy: {
      get() {
        return this.modelValue.start;
      },
      set(value) {
        this.modelProxy = {
          ...this.modelProxy,
          start: value,
        };
      },
    },
    modelEndProxy: {
      get() {
        return this.modelValue.end;
      },
      set(value) {
        this.modelProxy = {
          ...this.modelProxy,
          end: value,
        };
      },
    },
  },
  methods: {
    clear() {
      this.modelProxy = {
        start: null,
        end: null,
      };
    },
  },
};
</script>

<style lang="scss" module>
.field {
  position: relative;
  display: inline-flex;
  padding: 9px 6px 9px 8px;
  font-size: 16px;
  font-weight: 500;
  color: $title;
  background-color: $white;
  border: 2px solid $border;
  border-radius: 5px;

  &.hasClearButton {
    padding-right: 30px;
  }

  &:hover {

    .clear:not(.isHidden) {
      opacity: 1;
    }
  }
}

.value {
  cursor: default;
}

.placeholder {
  color: rgba($text, 0.5);
}

.divider {
  display: inline-block;
  margin-right: 5px;
  margin-left: 5px;
}

.picker {
  display: flex;
  flex-grow: 1;
}

.pickerValue {
  flex-grow: 1;
}

.clear {
  @include reset;
  position: absolute;
  top: 50%;
  right: 7px;
  display: inline-flex;
  padding: 3px;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
  transform: translateY(-50%);

  &.isHidden {
    pointer-events: none;
    opacity: 0;
  }

  svg {
    width: 10px;
    height: auto;
  }
}
</style>
